import { type GkAirRecommendedProductDataWeb } from '@redteclab/api/clients/crosssellers-proxy-service'

import {
  type RecommendationServiceType,
  useRecommendationWidgetContext,
} from '../../../../recommendation'
import { useProductPageUdpTrackingAddToCart } from '../../ProductBuyBox/hooks/useProductPageUdpTrackingAddToCart'

type UsePdpBuyTogetherUdpTrackingParams = {
  recommendedProduct: GkAirRecommendedProductDataWeb
}

type UsePdpBuyTogetherUdpTrackingResult = {
  serviceId: RecommendationServiceType | undefined
  trackUdpAddToCart: () => void
  widgetId: string | undefined
}

export const usePdpBuyTogetherUdpTracking = ({
  recommendedProduct,
}: UsePdpBuyTogetherUdpTrackingParams): UsePdpBuyTogetherUdpTrackingResult => {
  const { serviceId, trackUdpProductAddToCart, widgetId } =
    useRecommendationWidgetContext()
  const trackPdpAddToCart = useProductPageUdpTrackingAddToCart(1)

  const trackUdpAddToCart = (): void => {
    // Track the original PDP product with the impression that led to the PDP.
    trackPdpAddToCart()
    // Track the recommended product with the current buy-together widget impression.
    trackUdpProductAddToCart?.({
      quantity: 1,
      upid: recommendedProduct.UID,
    })
  }

  return { serviceId, trackUdpAddToCart, widgetId }
}
